module.exports = __webpack_public_path__ + "static/img/case_banner.adc616ce.jpg";